import { UserProfile } from 'fitbeat.gym-core';
import React, { PureComponent } from 'react';
import { translate } from 'react-i18next';
import { ActivityIndicator, StyleSheet, Text, View } from 'react-native';
import QRCode from 'react-qr-code';
import { connect } from 'react-redux';
import InstallApp from '../Bookings/components/InstallApp';
import { Button, ButtonTypes } from '../components';
import { getConfig } from '../config';
import { IAppStore } from '../HomeWorkouts';
import Theme from '../theme';
import {
  clearDeepLinkParams as clearDeepLinkParamsAction,
  isMobileWeb,
  LogoutHelper,
  UserDataConsumer,
} from '../utils';
import { defaultScale } from '../utils/scaling';
import { installAppScreenMounted as installAppScreenMountedAction } from './actions';
import { InstallAppButton } from './components';

interface IProps {
  userProfile?: UserProfile;
  userEmail?: string;
  userIsAuthenticated: boolean;
  loading: boolean;
  installAppScreenMounted(): void;
  t(key: string, options?: any): string;
  handleSubmit(cb: any): void;
  reset(): void;
  clearDeepLinkParams(params: string[]): void;
}

interface IState {
  error: string | null;
  countryCode: string | null;
  phone: string | null;
  mobileNumber: string | null;
  loading: boolean;
}

class HomeInstallApp extends PureComponent<IProps, IState> {
  public state = {
    error: null,
    countryCode: null,
    phone: null,
    mobileNumber: null,
    loading: false,
  };
  public mobileNumberInput: any;

  constructor(props: any) {
    super(props);
  }

  public componentDidMount() {
    this.props.clearDeepLinkParams(['route']);
    this.props.installAppScreenMounted();
  }

  public screenFooter = () => {
    const { t, userIsAuthenticated, userProfile } = this.props;
    const logoutContent = userIsAuthenticated ? <Button
      title={t('logout')}
      fontColor={Theme.PRIMARY}
      buttonType={ButtonTypes.TRANSPARENT}
      containerStyle={{ marginTop: defaultScale(10) }}
      onPress={() => LogoutHelper()}
    /> : <></>;

    if (isMobileWeb()) {
      return (
        <>
          <InstallAppButton t={t} useButtonStyle overrideLink={userProfile?.continueSignupLink} />
          {logoutContent}
        </>
      );
    }
    return (
      <>
        <View style={styles.QRContainer}>
          <Text style={[styles.formHeader, { paddingBottom: defaultScale(15) }]}>
            {t('scanQRToInstall')}
          </Text>

          <QRCode
            value={this.QRCodeLink()}
            viewBox={`0 0 192 192`}
            size={192}
          />
        </View>
        {logoutContent}
      </>
    );
  }

  public render() {
    const { t, loading } = this.props;

    if (loading) {
      return (
        <View style={[styles.container, { justifyContent: 'center', height: '100%' }]}>
          <ActivityIndicator
            size={'small'}
            color={Theme.PRIMARY}
            animating
          />
        </View>
      );
    }

    return (
      <View style={{height: '100%', backgroundColor: isMobileWeb() ? Theme.GREY_DARK : Theme.WHITE}}>
        <InstallApp
          header={t('bookings:continueOnTheApp')}
          actionButtons={this.screenFooter()}
        />
      </View>
    );
  }

  private QRCodeLink = (): string => {
    const { userProfile } = this.props;
    if (userProfile?.continueSignupLink) {
      return userProfile.continueSignupLink;
    }
    return getConfig().appDownloadUrl;
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: isMobileWeb() ? 'flex-end' : 'flex-start',
    backgroundColor: isMobileWeb() ? Theme.GREY_DARK : Theme.WHITE,
  },
  formHeader: {
    ...Theme.textStyle.bodyCopyReg,
    paddingTop: defaultScale(20),
    textAlign: 'center',
  },
  QRContainer: {
    paddingVertical: defaultScale(10),
    alignItems: 'center',
  },
});

const mapStateToProps = (state: IAppStore, ownProps) => ({
  userEmail: ownProps.user?.userProfile?.email ||
    state.deepLinkParamaters.email || state.auth.signup.continueSignupUserProfile?.email,
  userProfile: ownProps.user?.userProfile || state.auth.signup.continueSignupUserProfile,
  userIsAuthenticated: !!ownProps.user?.userProfile,
  loading: state.auth.signup.installAppScreenLoading,
});

const mapDispatchToProps = (dispatch) => ({
  clearDeepLinkParams: (params) => dispatch(clearDeepLinkParamsAction(params)),
  installAppScreenMounted: () => dispatch(installAppScreenMountedAction()),
});

export const HomeInstallAppScreen = translate(['auth', 'formFields'], { wait: true })(
  UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(HomeInstallApp)),
);
